import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ModuleSelection } from './components/ModuleSelection';
import { ProductionModule } from './modules/ProductionModule';
import { UserProvider } from './context/UserContext';
import { Impressum } from './components/Impressum';
export function App() {
  return <UserProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<ModuleSelection data-id="element-4" />} data-id="element-3" />
          <Route path="/production/*" element={<ProductionModule data-id="element-6" />} data-id="element-5" />
          <Route path="/laboratory" element={<div data-id="element-8">Labor Modul (In Entwicklung)</div>} data-id="element-7" />
          <Route path="/disposition" element={<div data-id="element-10">Disposition Modul (In Entwicklung)</div>} data-id="element-9" />
          <Route path="/impressum" element={<Impressum data-id="element-12" />} data-id="element-11" />
        </Routes>
      </BrowserRouter>
    </UserProvider>;
}